// extracted by mini-css-extract-plugin
module.exports = {"rotate":"PopupContainer_rotate__3IsnL","animation":"PopupContainer_animation__yOZ6j"};